<template>
  <ngc-modal
    :open="value"
    :variant="!!selectedFile ? 'decide' : 'dismiss'"
    :title.prop="'Add profile photo'"
    primary-action-text="Save"
    :loading="imageSaving"
    @primary-action-click="saveDialog"
    @close="closeDialog"
  >
    <div v-if="!imageSaving">
      <div class="photo-hint">
        Recommended dimensions 192x192 pixels. Jpg or png of 5MB or less
      </div>

      <sn-photo-uploader
        class="mb-6"
        :image="selectedFile"
        :aspect-ratio="1"
        cropper-width="300"
        cropper-height="450"
        :may-remove="true"
        @image="onFileSelect"
      />
    </div>

    <div
      v-if="imageSaving"
      class="loading-content"
    >
      <div
        id="loadingView"
        ref="loadingView"
        style="height: 100px; width: 100px;"
      />
    </div>
  </ngc-modal>
</template>

<script>

import lottie from 'lottie-web'
import loadingJSON from '~/assets/lottieAnimations/loading.json'

export default {
  name: 'PhotoUploader',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    onSave: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      selectedFile: null,
      imageSaving: false
    }
  },
  methods: {
    onFileSelect (img) {
      this.selectedFile = img
    },
    closeDialog () {
      this.error = ''
      this.selectedFile = null
      this.$emit('close')
    },
    async saveDialog () {
      if (this.selectedFile == null) {
        return
      }

      this.imageSaving = true
      this.$nextTick(() => {
        this.mountAnimation()
        this.animation.loop = true
        this.animation.play()
      })

      this.$emit('image', { filename: this.selectedFile.filename, dataURL: this.selectedFile.dataURL })

      this.$nextTick(async () => {
        try {
          await this.onSave()
        } catch (err) {
          console.error('Error saving dialog: ', err)
        }

        this.imageSaving = false
        this.animation.stop()
        this.animation.destroy()

        this.closeDialog()
      })
    },
    mountAnimation () {
      this.animation = lottie.loadAnimation({
        container: this.$refs.loadingView,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: loadingJSON
      })
    }
  }
}
</script>

<style scoped>

.photo-hint {
  color: #667085;
  margin-bottom: 16px;
}

.loading-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 295px;
}

</style>
